import { ErrorCodes } from '../utils/ErrorCodes';

export default class ThinClientInterface {
	static hasPrinters = false;

	static printerList = [];

	// regex search criteria for printers to exclude
	static printerExclude = /(fax)|(webex)|(onenote)|(DYMO LabelWriter 450 DUO Tape)/i;

	/**
	 * Initializes ThinClientInterface
	 */
	static init = () => {
		this.refreshPrinters(printerList => {
			this.printerList = printerList;
		});
	};

	/**
	 * Get Printer Information from ThinClient
	 * @return {Promise<Array>}
	 */
	static getPrinterInfo = () =>
		new Promise(resolve => {
			const xhr = new XMLHttpRequest();
			xhr.open('GET', 'stamps-com-native-app://get-printer-info');
			xhr.onload = e => {
				const printerInfo = JSON.parse(e.target.responseText);
				if (printerInfo.printer && printerInfo.printer.length > 0) {
					this.hasPrinters = true;
					resolve(printerInfo.printer);
				} else {
					this.hasPrinters = false;
					resolve([]);
				}
			};
			xhr.send();
		});

	static getPrinterNamesArray = printerList =>
		printerList.map(printerObj =>
			typeof printerObj === 'object' ? printerObj.name : 'printerObj invalid'
		);

	/**
	 * Filter Printers list.
	 */
	static filterPrinters = rawPrinters => {
		if (!Array.isArray(rawPrinters)) return [];

		return rawPrinters.filter(printer => !this.printerExclude.test(printer.name));
	};

	/**
	 * Update Printer information if the printer is connected to the computer after ThinClient starts.
	 * @param {function} callback to be executed after printer info refresh
	 */
	static refreshPrinters = async callback => {
		const printerList = await this.getPrinterInfo();
		const filteredPrinters = this.filterPrinters(printerList);
		if (callback) callback(filteredPrinters);
	};

	/**
	 * Get Weight from ThinClient.
	 * @return {Promise<Object>}
	 */
	static getWeight = () =>
		new Promise(resolve => {
			const xhr = new XMLHttpRequest();
			xhr.open('GET', 'stamps-com-native-app://get-scale-weight');
			xhr.onload = e => {
				const tenthsOfOunces = JSON.parse(e.target.responseText);
				resolve({
					errorCode:
						tenthsOfOunces >= 0
							? ErrorCodes.SUCCESS
							: ErrorCodes.plugin.SCALE_CALIBRATE_FAILED,
					weight: tenthsOfOunces,
				});
			};
			xhr.send();
		});

	/**
	 * Calibrate Scale value when weight is negative.
	 * @return {Promise<Object>}
	 */
	static resetScale = () =>
		new Promise(resolve => {
			const xhr = new XMLHttpRequest();
			xhr.open('GET', 'stamps-com-native-app://zero-scale');
			xhr.onload = e => {
				const resetScaleResult = JSON.parse(e.target.responseText);
				resolve(resetScaleResult);
			};
			xhr.send();
		});

	/**
	 * Submits Print Job to ThinClient.
	 * @param {string} printUrl
	 * @return {Promise<Object>}
	 */
	static print = (printUrl, callback) =>
		new Promise(resolve => {
			const printCommandWithTabs = printUrl.replace(/\\t/g, '\t');
			const printJob = {
				printJob: printCommandWithTabs,
			};
			const xhr = new XMLHttpRequest();

			xhr.open('POST', 'stamps-com-native-app://submit-print-job/', true);
			xhr.setRequestHeader('Content-Type', 'application/json');
			xhr.onload = e => {
				const printJobResult = e.target.responseText;
				if (callback) callback(printJobResult);
				resolve(printJobResult);
			};
			xhr.send(JSON.stringify(printJob));
		});
}
